import {
    LIST_INVOICES_REQUEST,
    LIST_INVOICES_SUCCESS,
    LIST_INVOICES_FAILURE,
} from 'api/index';

const initialSettings = null;

const invoices = (state = initialSettings, action) => {
    switch (action.type) {
        
        case LIST_INVOICES_SUCCESS:
            return {
                ...state,
                payment: action.payload.payment,
                openInvoices: action.payload.openInvoices,
                bookings: action.payload.bookings,
            };

        case LIST_INVOICES_REQUEST:
        case LIST_INVOICES_FAILURE:
            return {
                ...state,
                payment: null,
                openInvoices: null,
                bookings: null,
            };

        default:
            return state;
    }
};

export default invoices;